export default {
  virtualCardList: {
    data: null,
    error: null,
    loading: false,
  },
  addVirtualCard: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
  addMoneyToVirtualCard: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
  cardStatus: {
    data: null,
    error: null,
    loading: false,
  },
  renewVirtualCard: {
    data: null,
    error: null,
    loading: false,
  },
  redeeMoney: {
    data: null,
    error: null,
    loading: false,
  },
};
